var $e33d3b3868478b04$exports = {};
$e33d3b3868478b04$exports = {
  "close": "\xCEnchide\u0163i",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " notificare");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " notific\u0103ri");
      }
    }), ".");
  }
};
export { $e33d3b3868478b04$exports as default };